__turbopack_context__.v({
  "header": "header-module-scss-module__CycGqq__header",
  "headerEnter": "header-module-scss-module__CycGqq__headerEnter",
  "headerGlow": "header-module-scss-module__CycGqq__headerGlow",
  "headerInner": "header-module-scss-module__CycGqq__headerInner",
  "link": "header-module-scss-module__CycGqq__link",
  "logo": "header-module-scss-module__CycGqq__logo",
  "menuButton": "header-module-scss-module__CycGqq__menuButton",
  "menuButtonIcon": "header-module-scss-module__CycGqq__menuButtonIcon",
  "nav": "header-module-scss-module__CycGqq__nav",
  "navIndicator": "header-module-scss-module__CycGqq__navIndicator",
  "navLink": "header-module-scss-module__CycGqq__navLink",
  "navLinkActive": "header-module-scss-module__CycGqq__navLinkActive",
});
